<template>
  <div id="pageModules">
    <v-container grid-list-xl fluid>
      <!-- Page header -->
      <div class="modern-page-header">
        <div class="modern-page-header__left">
          <div class="modern-page-header__icon-wrap">
            <v-icon class="modern-page-header__icon">extension</v-icon>
          </div>
          <div>
            <h3 class="modern-page-header__title">Manage Modules</h3>
            <p class="modern-page-header__sub">Create and assign feature modules to schools</p>
          </div>
        </div>
      </div>

      <add-module ref="moduleList" @addModule="setModule"></add-module>

      <v-dialog v-model="mode" max-width="600px">
        <assign-module :mod="mod" @exit="reloadModules"></assign-module>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import AddModule from "./AddModule";
import AssignModule from "./AssignModule";
export default {
  components: { AddModule, AssignModule },
  data() {
    return {
      mod: {},
      mode: false
    };
  },
  methods: {
    reloadModules: function() {
      this.mode = false;
    },
    setModule: function(obj) {
      this.mode = true;
      this.mod = obj;
    }
  }
};
</script>

<style scoped lang="css">
.modern-page-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 0 20px; flex-wrap: wrap; gap: 16px;
}
.modern-page-header__left { display: flex; align-items: center; gap: 16px; }
.modern-page-header__icon-wrap {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #1565C0, #0d47a1);
  display: flex; align-items: center; justify-content: center;
}
.modern-page-header__icon { color: #ffffff !important; font-size: 22px !important; }
.modern-page-header__title {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 1.3rem;
  font-weight: 700; color: #1e293b; margin: 0; letter-spacing: -0.3px;
}
.modern-page-header__sub {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 13px;
  color: #64748b; margin: 2px 0 0;
}
</style>
